export const get={method:'get'}
export const post={method:'post'}
export const postForm={method:'post',headers:{'Content-Type':'multipart/form-data'}}